module.exports = __webpack_public_path__ + "img/Lead.47bae853.svg";